module.exports = "//img1.rrcimg.com/_next/static/src/assets/fz_mNwMR.png";